import { Button, TextField } from "@material-ui/core";
import * as React from "react";
import { FC } from "react";
import { useNotify, Notification, useLogin } from "react-admin";
import "./index.css";

const Login: FC = () => {
  const notify = useNotify();
  const login = useLogin();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  let [loading, setLoading] = React.useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !password) {
      notify("All fields must be filled");
      return;
    };
    setLoading(true);
    login({ email, password }).then((result)=>{
      if (!result) {
        notify("Wrong Credential","error")
      }
    }).catch((error) => {
      setLoading(false);
      notify("Invalid email or password");
    });
  };

  return (
    <div className="login-wrap">
      <div className="login-form-wrap">
        <div className="raffle-logo">
          <img src={require("../../../extensions/images/icon.png")} />
        </div>
        <form onSubmit={submit}>
          <TextField
            id="standard-basic"
            name="email"
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            id="standard-password-input"
            name="password"
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            variant="contained"
            type="submit"
            className="sign-in-button"
            disabled={loading}
            fullWidth
          >
            Sign In
          </Button>
        </form>
      </div>
      <Notification />
    </div>
  );
};

export default Login;
